// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider-28_XkSQ2NWhga5xQH2sKhG"};